import { NgModule } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { Log } from 'ng2-logger';

const log = Log.create('authHttpServiceFactory');

export function authHttpServiceFactory (http: Http, options: RequestOptions)  {

  // by default all calls should pass along cookies
  options.withCredentials = true;

  return new AuthHttp(new AuthConfig({
    tokenGetter: () => {
      return (window as any).accessToken;
    },
  }), http, options);
}

@NgModule({
  providers: [
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [Http, RequestOptions]
    }
  ]
})
export class EditAuthModule {}



// WEBPACK FOOTER //
// ./src/app/_modules/auth.module.ts